import RestService from './RestService';

const PasswordService = {
  reSign: token => RestService.post(`/api/v1/resigns/resign/${token}`),
  getCustomerInfo: token => RestService.get(`/api/v1/resigns/offer?tokenId=${token}`)
};

export default PasswordService;



/** WEBPACK FOOTER **
 ** ./src/services/ReSignService.js
 **/